import React from 'react';
import { Box, useMediaQuery } from '@mui/material';

const SliderImages = ({ images }) => {

    const isMobile = useMediaQuery('(max-width:800px)');

    const isVimeoLink = (src) => {
        return src.startsWith('https://vimeo.com/') || src.startsWith('https://player.vimeo.com/');
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                overflow: 'visible',
                gap: isMobile ? 3 : 9, // Espacement entre les images
            }}
        >
            {images.length > 0 ? (
                images.map((src, index) =>
                    isVimeoLink(src) ? (
                        <>
                            <div style={{
                                padding: "56.25% 0 0 0",
                                position: 'relative'
                            }}>
                                <iframe src={src} frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style={{position: "absolute", top:"0", left:"0", width:"100%", height: "100%"}} title="Video Player">
                                </iframe>
                            </div>
                            <script src="https://player.vimeo.com/api/player.js"></script>
                        </>
                    ) : (
                        <img
                            key={index}
                            src={src}
                            alt={`Slide ${index + 1}`}
                            style={{
                                width: '100%',
                            }}
                        />
                    )
                )
            ) : (
                <p>Aucune image trouvée pour ce projet.</p>
            )}
        </Box>
    );
};

export default SliderImages;
